export const PUBLIC_PAGE_ROUTES = Object.freeze([
  "pricing",
  "payment-success",
  "payment-fail",
  "install",
  "login-success",
  "sns-signup",
  "contact",
  "api-docs",
  "api-keys",
  "guide",
  "freight",
  "exchange",
  "forms",
  "news",
  "cases",
  "taxcalc",
  "trade-codes",
  "req-agencies",
  "fta",
]);

const PUBLIC_PAGE_ROUTE_SET = new Set(PUBLIC_PAGE_ROUTES);

export function publicPageHref(page) {
  return PUBLIC_PAGE_ROUTE_SET.has(page) ? `/?page=${page}` : "/";
}

/**
 * Keep the rendered public page and the browser URL in sync.
 *
 * Portal pages used to update React state only. Returning to the landing page
 * from /?page=exchange therefore left the exchange query behind, and a later
 * fragment navigation (for example #data) could restore the stale tool page.
 */
export function navigatePublicPage(page, setCurrentPage, { replace = false } = {}) {
  const href = publicPageHref(page);
  const currentHref = `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (currentHref !== href) {
    window.history[replace ? "replaceState" : "pushState"]({}, "", href);
  }
  setCurrentPage(page);
}
